var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Add_Button",
    "data-name": "Add Button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 32,
    height: 32,
    rx: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-circle",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M1.25,13.25a12,12,0,1,1,12,12A12.01,12.01,0,0,1,1.25,13.25Zm1.674,0A10.326,10.326,0,1,0,13.25,2.924,10.338,10.338,0,0,0,2.924,13.25Z",
    transform: "translate(-1.25 -1.25)",
    fill: "#15345a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M8.15,13.05a.9.9,0,1,1,0-1.8h9.6a.9.9,0,1,1,0,1.8Z",
    transform: "translate(-0.95 -0.15)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M11.25,17.75V8.15a.9.9,0,1,1,1.8,0v9.6a.9.9,0,1,1-1.8,0Z",
    transform: "translate(-0.15 -0.95)",
    fill: "#15345a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/Add_Button.84fe12aaba67ed4f3e30d473aff05f52.svg";
export { ForwardRef as ReactComponent };